class ComponentProductBar extends Theme.Component {
  #submitting = false;

  connectedCallback() {

    this.onSubmit = this.onSubmit.bind(this);

    this.defineElements({
      form: "form"
    });

    this.elements.form.setAttribute("action", "");
    this.elements.form.setAttribute("novalidate", "novalidate");
    this.elements.form.addEventListener("submit", (e) => e.preventDefault(), true);

    this.addEvent("submit", this.elements.form, this.onSubmit);
    this.addEvent("product:variantchange", document, this.onVariantChange);

    const submitButtons = this.elements.form.querySelectorAll('button[type="submit"], [data-action="add-to-cart"]');
    submitButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.onSubmit(e);
      });
    });

    this.elements.form.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
      }
    });

    this.observeProductSection();
    this.events();
  }

  observeProductSection() {
    const section = document.querySelector(".theme-sections > section:first-child");
    const announcement = document.getElementById("shopify-section-announcement");

    const observer = new IntersectionObserver((entries) => {
      const isActive = !entries[0].isIntersecting;
      this.classList.toggle("active--true", isActive);
      if (announcement) {
        if (isActive) {
          announcement.style.display = "none";
        } else {
          announcement.style.display = "";
        }
      }
    }, { rootMargin: "50px 0px 0px 0px" });

    observer.observe(section);
  }

  onSubmit(event) {
    event.preventDefault();

    const productForm = document.querySelector("form[action*='/cart/add']");
    if (productForm) {
      productForm.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  onVariantChange(event) {
    this.render({ variant: event.detail.variant_id });
  }

  render(params = {}) {
    const url = new URL(location.pathname, location.origin);

    url.searchParams.set("section_id", this.id);

    for (const [param, value] of Object.entries(params)) {
      url.searchParams.set(param, value);
    }

    fetch(url.href)
      .then(response => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fragment = doc.getElementById(this.id);

        this.replaceWith(fragment);
      });
  }
}

customElements.define("component-product-bar", ComponentProductBar);
